import regionApi from '~/clientApis/regionApi';
import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { FETCH_REGION_ERROR } from '~/consts/errorMessages';

export const fetchRegions = async (id: string): Promise<void> => {
    const { regionStore } = getStore();

    regionStore.setIsLoadingRegions(true);

    try {
        const regions = await regionApi.getRegionList(id);
        regionStore.setRegions(regions);
    } catch {
        showMessageModal('error', FETCH_REGION_ERROR);
    } finally {
        regionStore.setIsLoadingRegions(false);
    }
};
